export const GROUP_NAME = 'input-pincode'
